/* ASLI B. home: single-screen transition, no obsolete grid or scroll timelines. */
(() => {
  const instances = new Map();
  class GWEHome {
    constructor(root) {
      this.root = root;
      if (root.classList.contains('gwe-sticky-grid--direct')) {
        document.body.classList.add('gwe-home-menu-visible');
        return;
      }
      this.intro = root.querySelector('[data-gwe-intro]');
      this.onActivate = (event) => {
        if (event.type === 'keydown') {
          if (!['Enter', ' '].includes(event.key)) return;
          event.preventDefault();
        }
        this.enter();
      };
      this.intro?.addEventListener('click', this.onActivate);
      this.intro?.addEventListener('keydown', this.onActivate);
    }
    enter() {
      if (this.root.classList.contains('gwe-sticky-grid--entered')) return;
      const gsap = window.GWEMotion?.gsap || window.gsap;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const marquee = this.root.querySelector('[data-gwe-marquee]');
      const button = this.root.querySelector('.gwe-sticky-grid__button');
      const header = document.querySelector('.store-header');
      const nav = header ? Array.from(header.querySelectorAll('.desktop-nav,.desktop-actions__editorial-links,.store-header__actions,.mobile-header__left,.mobile-header__right')) : [];
      if (gsap && !reduced) {
        if (marquee) gsap.set(marquee, { opacity: 0, y: 16 });
        if (button) gsap.set(button, { opacity: 0, y: 12, pointerEvents: 'none' });
      }
      this.root.classList.add('gwe-sticky-grid--entered');
      this.intro?.setAttribute('aria-hidden', 'true');
      this.intro?.setAttribute('tabindex', '-1');
      this.intro?.removeAttribute('role');
      if (gsap && !reduced) {
        const timeline = gsap.timeline({ delay: .48 });
        if (nav.length) timeline.to(nav, { opacity: 1, duration: .65, stagger: .08, ease: 'power2.out' }, 0);
        timeline.call(() => document.body.classList.add('gwe-home-menu-visible'), null, .7);
        if (marquee) timeline.to(marquee, { opacity: 1, y: 0, duration: 1.05, ease: 'power2.out' }, '+=.15');
        if (button) timeline.to(button, { opacity: 1, y: 0, pointerEvents: 'auto', duration: .8, ease: 'power2.out' }, '+=.22');
        this.timeline = timeline;
      } else {
        document.body.classList.add('gwe-home-menu-visible');
        if (marquee) marquee.style.opacity = '1';
        if (button) { button.style.opacity = '1'; button.style.pointerEvents = 'auto'; }
      }
    }
    destroy() {
      this.timeline?.kill();
      document.body.classList.remove('gwe-home-menu-visible');
      this.intro?.removeEventListener('click', this.onActivate);
      this.intro?.removeEventListener('keydown', this.onActivate);
      instances.delete(this.root);
    }
  }
  const initialize = scope => {
    const roots = [...(scope.querySelectorAll?.('[data-gwe-sticky-grid]') || [])];
    if (scope.matches?.('[data-gwe-sticky-grid]')) roots.push(scope);
    roots.forEach(root => { if (!instances.has(root)) instances.set(root, new GWEHome(root)); });
  };
  const boot = () => {
    initialize(document);
    document.addEventListener('shopify:section:load', event => initialize(event.target));
    document.addEventListener('shopify:section:unload', event => {
      const root = event.target.matches?.('[data-gwe-sticky-grid]') ? event.target : event.target.querySelector?.('[data-gwe-sticky-grid]');
      if (root) instances.get(root)?.destroy();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();